// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import { GetClient, GetClientsSchema } from "@modules/client/constants/actions";
import actionCreators from "@modules/client/actionCreator";
import type { ClientResponse, ClientSchema } from "@modules/client/reducer/client/types";
import { parseSchema } from "@utils/schema";

type ItemResponse<T> = $Exact<T>;

type ClientRequest = $Exact<{
  clientId: string,
}>;

type GetClientResponse = $Exact<{
  data: ClientResponse,
}>;

export function* onGetClient({
  payload,
}: Action<ClientRequest>): Generator<*, void, GetClientResponse> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/client-admin/client/${payload.clientId}`,
    );

    yield put(actionCreators.GetClientSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetClientError(e.response));
  }
}

export function* onGetClientsSchema(): Generator<*, void, ItemResponse<ClientSchema>> {
  try {
    const schema = yield parseSchema("ClientDTO");
    yield put(actionCreators.SetClientsSchema(schema));
  } catch (e) {
    yield put(actionCreators.GetClientsSchemaError(e));
  }
}

// ROOT

export function* ClientSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetClient, onGetClient), takeEvery(GetClientsSchema, onGetClientsSchema)]);
}

export default ClientSagas;
